const UserDisplayedName = ({ user }) => {
  const {name, surname, email} = user || {}

  if (name || surname) {
    return `${name} ${surname}`;
  }
  if (email) {
    return `${email}`;
  }

  return null
}

export default UserDisplayedName;



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/UserDisplayedName.js